import React from 'react';
import { App } from './App';

export function Root() {
  return <App />;
}
